import { useMemo } from 'react';

import { NoOpenAmountCardResponse } from '@eneco/dc-be/client';
import { Stack, Text } from '@eneco/sparky';
import { CircleCheckmark } from '@eneco/sparky/illustrations';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';
import { DashboardLink } from './DashboardLink';
import { getPaymentMethodType } from '../../invoices/invoiceHandlers';

export const NoOpenAmountCard = ({ card }: { card: NoOpenAmountCardResponse }) => {
  const { fields } = useContent<DashboardOverviewRendering>();
  const { details } = card;
  const { summary } = details;
  const { records } = summary;

  const paymentMethods = new Set(records.map(r => r.paymentMethod));
  const paymentMethodType = getPaymentMethodType(paymentMethods);

  const message = useMemo(() => {
    if (paymentMethodType === 'DirectDebit') {
      return (
        fields.noOpenAmountCard.directDebitIncludingYearlyBillText?.value ??
        'Alles is in orde! Je volgende factuur zal aangeboden worden bij je bank. [not in sitecore]'
      );
    }
    if (paymentMethodType === 'DirectDebitExcludingYearlyBill') {
      return (
        fields.noOpenAmountCard.directDebitExcludingYearlyBillText?.value ??
        'Alles is in orde! Je volgende factuur zal aangeboden worden bij je bank (behalve de jaarafrekening). [not in sitecore]'
      );
    }
    return (
      fields.noOpenAmountCard.noOpenAmountText?.value ??
      'Alles is in orde! Je hebt geen openstaand bedrag voor al je producten. [not in sitecore]'
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMethodType]);

  return (
    <StyledDashboardBlock>
      <Stack gap="4" direction="row" alignY={'center'}>
        <Stack.Item shrink={false}>
          <CircleCheckmark color="feedbackSuccess" size="large" />
        </Stack.Item>
        <Text>{message}</Text>
      </Stack>
      <DashboardLink
        href={fields.noOpenAmountCard.link.value.href}
        emphasis="high"
        trackingComponentName="no_open_amount_link"
        trackingComponentType="dashboard_link">
        {fields.noOpenAmountCard.link.value.text}
      </DashboardLink>
    </StyledDashboardBlock>
  );
};
